import { Model } from "@interfaces/model.interface";

export interface ContractPayment extends Model {
	actualCost: number;
	contractId: number;
	costDelta: number;
	estimatedCost: number;
	invoiceDate: Date;
	notes: string;
	paymentDate: Date;
}

export class ContractPayment implements ContractPayment {
	constructor(data?: Partial<ContractPayment>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}